import { loadModule } from 'holocron';
import { setSubmittedAction } from '../ducks/formDuck';
import { getRequest } from '../selectors/requestSelectors';
import { getFilters } from '../selectors/filtersSelectors';
import { getHasErrors } from '../selectors/validationSelectors';
import saveCommonCacheThunk from './saveCommonCacheThunk';
import savePackagesCacheThunk from './savePackagesCacheThunk';
import { setIsSearchSubmitting } from '../ducks/searchDuck';
import { MODULE_NAME_SEARCH_REDIRECT } from '../constants/packagesConstants';

export const onSubmitThunk = (horizonsConfig) => async (dispatch, getState) => {
  dispatch(setSubmittedAction(true));
  const state = getState();

  if (!getHasErrors(state)) {
    dispatch(setIsSearchSubmitting(true));
    dispatch(saveCommonCacheThunk());
    dispatch(savePackagesCacheThunk());
    const request = getRequest(state);
    const filters = getFilters(state);
    const SearchRedirect = dispatch(loadModule(MODULE_NAME_SEARCH_REDIRECT));
    const { searchPackages } = await SearchRedirect;
    dispatch(searchPackages(
      { ...request.toJS(), ...filters.toJS(), horizonsConfig }
    ));
  }
};

export default onSubmitThunk;
